import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { useUserKeyLookupQueryContext } from '../contexts/UserKeyLookupQueryContext';

export const useRedirectOnSuccessfulLookup = () => {
  const { userKey } = useUserKeyLookupQueryContext();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userKey || isRedirecting) return;
    setIsRedirecting(true);
    navigate(`/users/profiles/${encodeURIComponent(userKey)}`);
  }, [isRedirecting, navigate, userKey]);

  return { isRedirecting };
};
